module.exports = __webpack_public_path__ + "img/sx.c6f2b53c.png";